// assets
import { IconUsers, IconShield, IconKey, IconSettings } from '@tabler/icons-react';

// constant
const icons = { IconUsers, IconShield, IconKey, IconSettings };

// ==============================|| QUẢN TRỊ HỆ THỐNG (Admin) ||============================== //

const admin = {
    id: 'admin',
    title: 'Quản trị hệ thống',
    type: 'group',
    icon: icons.IconSettings,
    children: [
        {
            id: 'role-management',
            title: 'Phân quyền',
            type: 'item',
            url: '/admin/roles',
            icon: icons.IconShield,
            breadcrumbs: false
        },
        {
            id: 'permission-management',
            title: 'Quyền hạn',
            type: 'item',
            url: '/admin/permissions',
            icon: icons.IconKey,
            breadcrumbs: false
        },
        {
            id: 'user-management',
            title: 'Người dùng',
            type: 'item',
            url: '/admin/users',
            icon: icons.IconUsers,
            breadcrumbs: false
        }
    ]
};

export default admin;
